webpackJsonp([171778037205648,96834539877599,157577309833566,59241454930223,110014525997173,53477440259974],{

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = CabifyIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CabifyIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "20", height: "22", viewBox: "0 0 18 22" },
	    _react2.default.createElement("path", { d: "M8.87,6.07A2.91,2.91,0,0,1,11,7a2.92,2.92,0,0,0,4.19,0,3.12,3.12,0,0,0,0-4.3A8.78,8.78,0,0,0,8.87,0,9,9,0,0,0,0,9.11a9.22,9.22,0,0,0,2.6,6.44L8.87,22l6.27-6.44a3.12,3.12,0,0,0,0-4.3,2.92,2.92,0,0,0-4.19,0L8.87,13.41,6.78,11.26a3.07,3.07,0,0,1-.86-2.14A3,3,0,0,1,8.87,6.07ZM5.74,12.34l3.14,3.23L12,12.34a1.45,1.45,0,0,1,2.08,0,1.55,1.55,0,0,1,0,2.14L8.88,19.86,3.64,14.49A7.73,7.73,0,0,1,1.48,9.11,7.49,7.49,0,0,1,8.87,1.52,7.32,7.32,0,0,1,14.1,3.74a1.55,1.55,0,0,1,0,2.14,1.45,1.45,0,0,1-2.08,0A4.38,4.38,0,0,0,8.87,4.55,4.5,4.5,0,0,0,4.43,9.11,4.64,4.64,0,0,0,5.74,12.34Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Quote;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _iconModule = __webpack_require__(260);
	
	var _iconModule2 = _interopRequireDefault(_iconModule);
	
	var _backgroundModule = __webpack_require__(258);
	
	var _backgroundModule2 = _interopRequireDefault(_backgroundModule);
	
	var _generalModule = __webpack_require__(259);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _backgroundModule2.default, _iconModule2.default));
	
	var bgValues = ['marvel', 'green', 'teal', 'yellow', 'orange', 'pink', 'purple', 'red'];
	
	function Quote(_ref) {
	  var boldContent = _ref.boldContent,
	      caption = _ref.caption,
	      content = _ref.content,
	      headingSize = _ref.headingSize,
	      icon = _ref.icon,
	      iconColor = _ref.iconColor,
	      isLight = _ref.isLight,
	      linkText = _ref.linkText,
	      linkUrl = _ref.linkUrl,
	      tag = _ref.tag;
	
	  var headingProps = {
	    tag: tag,
	    weight: 'regular',
	    size: headingSize,
	    color: isLight ? 'white' : 'black'
	  };
	  var iconClassName = cx('icon', iconColor);
	  var Icon = icon;
	  var iconProps = {
	    className: iconClassName,
	    style: {
	      width: '40px',
	      height: '40px'
	    }
	  };
	
	  return _react2.default.createElement(
	    'figure',
	    null,
	    icon && (iconColor ? _react2.default.createElement(
	      'div',
	      iconProps,
	      _react2.default.createElement(Icon, null)
	    ) : _react2.default.createElement(Icon, null)),
	    _react2.default.createElement(
	      'blockquote',
	      { className: _generalModule2.default.heading },
	      _react2.default.createElement(
	        _heading2.default,
	        headingProps,
	        boldContent && _react2.default.createElement(
	          'span',
	          { className: 'fontWeight-6' },
	          boldContent
	        ),
	        ' ',
	        content
	      )
	    ),
	    caption && _react2.default.createElement(
	      'figcaption',
	      { className: _generalModule2.default.caption },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { color: isLight ? 'smoke' : 'slate', size: 'm' },
	        caption,
	        ' ',
	        linkText && _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: linkUrl },
	          _react2.default.createElement(
	            _link2.default,
	            { type: isLight ? 'blue' : 'blue' },
	            _react2.default.createElement(
	              'span',
	              { className: 'fontWeight-5' },
	              linkText
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	Quote.propTypes = {
	  boldContent: _propTypes2.default.string,
	  caption: _propTypes2.default.string,
	  content: _customPropTypesCheck2.default,
	  headingSize: _propTypes2.default.oneOf(['xxl', 'xxxl', 'xxxxl']),
	  icon: _propTypes2.default.func,
	  iconColor: _propTypes2.default.oneOf(bgValues),
	  isLight: _propTypes2.default.bool,
	  linkText: _propTypes2.default.string,
	  linkUrl: _propTypes2.default.string,
	  tag: _propTypes2.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5'])
	};
	
	Quote.defaultProps = {
	  isLight: false,
	  headingSize: 'xxl',
	  tag: 'h3'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"marvel":"src-components-modules-Quote-style----background-module---marvel---1ju4u bg-marvel","green":"src-components-modules-Quote-style----background-module---green---1XAIQ bg-green","teal":"src-components-modules-Quote-style----background-module---teal---2emPp bg-teal","yellow":"src-components-modules-Quote-style----background-module---yellow---2POad bg-yellow","orange":"src-components-modules-Quote-style----background-module---orange---2eGLm bg-orange","pink":"src-components-modules-Quote-style----background-module---pink---gSBHq bg-pink","purple":"src-components-modules-Quote-style----background-module---purple---3Tth- bg-purple","red":"src-components-modules-Quote-style----background-module---red---2e257 bg-red"};

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heading":"src-components-modules-Quote-style----general-module---heading---243Zz","caption":"src-components-modules-Quote-style----general-module---caption---3iape marginTop-s"};

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"src-components-modules-Quote-style----icon-module---icon---1rokL alignItems-center borderRadius-circle display-flex fill-white justifyContent-center marginBottom-m"};

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = HubBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Quote = __webpack_require__(119);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _CabifyIcon = __webpack_require__(524);
	
	var _CabifyIcon2 = _interopRequireDefault(_CabifyIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var quote = {
	  content: '“If we added up all the time it would take to discuss new features and designs without using Marvel, it would definitely add weeks to the design process.”',
	  caption: 'Rene Galindo, Lead Product Designer at Cabify — ',
	  linkText: 'Read Case Study',
	  linkUrl: '/case-studies/cabify'
	};
	
	function HubBlock() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bg-snow' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 'm' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'padding', size: 'xl', position: 'leftRight' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'padding', size: 'l', position: 'topBottom' },
	            _react2.default.createElement(_Quote2.default, _extends({}, quote, { icon: _CabifyIcon2.default, iconColor: 'purple' }))
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = DirectoryBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaMultipleImages = __webpack_require__(30);
	
	var _MediaMultipleImages2 = _interopRequireDefault(_MediaMultipleImages);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ParallaxWrapper = __webpack_require__(28);
	
	var _ParallaxWrapper2 = _interopRequireDefault(_ParallaxWrapper);
	
	var _Pattern = __webpack_require__(31);
	
	var _Pattern2 = _interopRequireDefault(_Pattern);
	
	var _Shape = __webpack_require__(27);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _assets = __webpack_require__(96);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DirectoryBlock(_ref) {
	  var color = _ref.color;
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 12, alignItems: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 7 },
	          _react2.default.createElement(
	            _MediaMultipleImages2.default,
	            {
	              fallbackImageAlt: 'See what everyone is working on',
	              fallbackImageSrc: _assets2.default.directoryFallback.src,
	              fallbackImageMaxWidth: 550
	            },
	            _react2.default.createElement(_Shape2.default, {
	              type: 'rectangle',
	              color: 'lightOrange',
	              width: 400,
	              height: 345
	            }),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1 },
	              _react2.default.createElement(_Pattern2.default, {
	                color: color,
	                right: 'auto',
	                left: '24%',
	                top: 'auto',
	                bottom: '24%',
	                type: 'shortRectangle'
	              })
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1.7 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.directory, {
	                borderRadius: 'm',
	                left: '30%',
	                maxWidth: 400,
	                position: 'absolute',
	                top: '28%'
	              })),
	              _react2.default.createElement(
	                _ParallaxWrapper2.default,
	                null,
	                _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.personRow, {
	                  borderRadius: 'm',
	                  left: '27%',
	                  maxWidth: 452,
	                  position: 'absolute',
	                  top: '42%'
	                }))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 5 },
	          _react2.default.createElement(_HeadingBlock2.default, {
	            justifyContent: 'center',
	            justifyM: 'start',
	            maxWidth: 440,
	            title: 'Create and iterate, together',
	            copy: _react2.default.createElement(
	              'span',
	              null,
	              'It\'s our mission to democratise design collaboration which will improve the creative process - making design more inclusive, collaborative and innovative.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'Instant access to all company projects for your directory members, means full visibility for your colleagues and helps you get to your best idea fast.'
	            )
	          })
	        )
	      )
	    )
	  );
	}
	
	DirectoryBlock.propTypes = {
	  color: _propTypes2.default.string
	};
	
	DirectoryBlock.defaultProps = {
	  color: null
	};
	module.exports = exports['default'];

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = HubBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _assets = __webpack_require__(96);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _generalModule = __webpack_require__(752);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HubBlock() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xl', type: 'padding', position: 'top' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'm' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'top' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', sizeM: '0', type: 'bottom', position: 'top' },
	          _react2.default.createElement(_HeadingBlock2.default, {
	            maxWidth: 400,
	            size: 'xs',
	            justifyContent: 'center',
	            justifyM: 'start',
	            title: 'Cross-company collaboration ',
	            copy: _react2.default.createElement(
	              'span',
	              null,
	              'Keep everyone up to date using the features that make Marvel the perfect collaborative design platform.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'Add collaborators to projects, assign user roles and leave feedback through comments and annotations.'
	            )
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.background },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.hub, { hasShadow: false, maxWidth: 1440, block: true }))
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = TeamsBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaMultipleImages = __webpack_require__(30);
	
	var _MediaMultipleImages2 = _interopRequireDefault(_MediaMultipleImages);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ParallaxWrapper = __webpack_require__(28);
	
	var _ParallaxWrapper2 = _interopRequireDefault(_ParallaxWrapper);
	
	var _Diamonds = __webpack_require__(181);
	
	var _Diamonds2 = _interopRequireDefault(_Diamonds);
	
	var _Pattern = __webpack_require__(31);
	
	var _Pattern2 = _interopRequireDefault(_Pattern);
	
	var _Shape = __webpack_require__(27);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _assets = __webpack_require__(96);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamsBlock(_ref) {
	  var color = _ref.color;
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 12, alignItems: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 5 },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { minWidth: 770 },
	            _react2.default.createElement(_HeadingBlock2.default, {
	              justifyContent: 'center',
	              justifyM: 'start',
	              maxWidth: 430,
	              title: 'All your teams in one place',
	              copy: _react2.default.createElement(
	                'span',
	                null,
	                'Make it easy to pull in relevant teams onto individual projects with our teams feature, simply group users into teams of your choice. ',
	                _react2.default.createElement('br', null),
	                ' ',
	                _react2.default.createElement('br', null),
	                'This means it\'s effortless to identify and include the right people, when you need to, improving online design collaboration.'
	              )
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 7 },
	          _react2.default.createElement(
	            _MediaMultipleImages2.default,
	            {
	              fallbackImageAlt: 'See what everyone is working on',
	              fallbackImageSrc: _assets2.default.teamsFallback.src,
	              fallbackImageMaxWidth: 829
	            },
	            _react2.default.createElement(_Shape2.default, {
	              type: 'rectangle',
	              color: 'lightOrange',
	              width: 425,
	              height: 314
	            }),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1 },
	              _react2.default.createElement(_Pattern2.default, {
	                color: color,
	                left: '35%',
	                bottom: '35%',
	                top: 'auto',
	                type: 'shortRectangle'
	              }),
	              _react2.default.createElement(_Diamonds2.default, { left: '60%', top: '50%', color: 'orange--l' })
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1.7 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.directoryTeams, {
	                borderRadius: 'm',
	                left: '5%',
	                maxWidth: 650,
	                position: 'absolute',
	                top: '36%'
	              })),
	              _react2.default.createElement(
	                _ParallaxWrapper2.default,
	                null,
	                _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.marketingTeam, {
	                  borderRadius: 'm',
	                  left: '25%',
	                  maxWidth: 440,
	                  position: 'absolute',
	                  top: '26%'
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(_HeadingBlock2.default, {
	              justifyContent: 'center',
	              justifyM: 'start',
	              maxWidth: 430,
	              title: 'Work faster, better and together with every team',
	              copy: 'Marvel helps every team and contribute to ideas and design, no matter what department.'
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	TeamsBlock.propTypes = {
	  color: _propTypes2.default.string
	};
	
	TeamsBlock.defaultProps = {
	  color: null
	};
	module.exports = exports['default'];

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Features;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Feature = __webpack_require__(45);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _assets = __webpack_require__(96);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Features() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'l', sizeM: 'xl', position: 'topBottom', type: 'margin' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        null,
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xl', position: 'bottom', type: 'margin' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', position: 'topBottom', type: 'margin' },
	            _react2.default.createElement(_HeadingBlock2.default, {
	              title: 'Collaboration built for scale',
	              copy: _react2.default.createElement(
	                'span',
	                null,
	                'Companies globally are using Marvel to transform how their teams work together throughout the design process.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'With our design collaboration tool users share designs, receive feedback and make changes in one place. Helping them move faster and communicate better.'
	              ),
	              alignContent: 'center',
	              alignM: 'center'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _grid2.default,
	          { columns: 3, size: 'l' },
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 3, columnSpanM: 1 },
	            _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.sharedFolder, {
	              title: 'Shared folders',
	              copy: 'Keep company projects organised for internal and external stakeholders by building folders for different teams or related projects, whatever works for you.',
	              maxWidth: 365,
	              fontWeight: 'semibold'
	            }))
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 3, columnSpanM: 1 },
	            _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.feed, {
	              title: 'Activity notifications',
	              copy: 'See who\u2019s working on what and get activity notifications in real-time, whether they\'re design changes or feedback left in comments.',
	              maxWidth: 365,
	              fontWeight: 'semibold'
	            }))
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 3, columnSpanM: 1 },
	            _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.manageTeam, {
	              title: 'User Management',
	              copy: 'Set access and permissions to projects for everyone in your team from admin to external reviewer, ensuring you the security and control you need.',
	              maxWidth: 365,
	              fontWeight: 'semibold'
	            }))
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FeatureCollaboration;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BorderTop = __webpack_require__(458);
	
	var _BorderTop2 = _interopRequireDefault(_BorderTop);
	
	var _CtaDefault = __webpack_require__(61);
	
	var _CtaDefault2 = _interopRequireDefault(_CtaDefault);
	
	var _HeroMedia = __webpack_require__(147);
	
	var _HeroMedia2 = _interopRequireDefault(_HeroMedia);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _CaseStudyQuoteBlock = __webpack_require__(648);
	
	var _CaseStudyQuoteBlock2 = _interopRequireDefault(_CaseStudyQuoteBlock);
	
	var _DirectoryBlock = __webpack_require__(649);
	
	var _DirectoryBlock2 = _interopRequireDefault(_DirectoryBlock);
	
	var _HubBlock = __webpack_require__(650);
	
	var _HubBlock2 = _interopRequireDefault(_HubBlock);
	
	var _TeamsBlock = __webpack_require__(651);
	
	var _TeamsBlock2 = _interopRequireDefault(_TeamsBlock);
	
	var _UserManagementBlock = __webpack_require__(652);
	
	var _UserManagementBlock2 = _interopRequireDefault(_UserManagementBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_COLOR = 'orange';
	
	var buttons = [{
	  text: 'Sign up free',
	  link: '/signup/',
	  styles: {
	    shape: 'rounded',
	    size: 'large',
	    minWidth: 160
	  }
	}, {
	  text: 'Explore Plans',
	  link: '/pricing/',
	  styles: {
	    shape: 'rounded',
	    size: 'large',
	    kind: 'ghost',
	    minWidth: 160
	  }
	}];
	
	function FeatureCollaboration() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default.features.collaboration.title,
	      meta: [{
	        name: 'description',
	        content: _metadata2.default.features.collaboration.description
	      }, {
	        name: 'keywords',
	        content: _metadata2.default.features.collaboration.keywords
	      }],
	      header: { isLight: true },
	      footer: true
	    },
	    _react2.default.createElement(_HeroMedia2.default, {
	      backgroundColor: 'orange--l',
	      color: 'white',
	      tag: 'h1',
	      headline: 'Make Marvel your centralised space for collaborative ideas, design feedback and iterations',
	      headlineMaxWidth: 1000,
	      name: 'mkt_features_collaboration',
	      type: 'video'
	    }),
	    _react2.default.createElement(_HubBlock2.default, null),
	    _react2.default.createElement(_CaseStudyQuoteBlock2.default, { color: PAGE_COLOR }),
	    _react2.default.createElement(_DirectoryBlock2.default, { color: PAGE_COLOR }),
	    _react2.default.createElement(_TeamsBlock2.default, { color: PAGE_COLOR }),
	    _react2.default.createElement(
	      _BorderTop2.default,
	      null,
	      _react2.default.createElement(_UserManagementBlock2.default, null)
	    ),
	    _react2.default.createElement(_CtaDefault2.default, {
	      bgColor: 'snow',
	      buttons: buttons,
	      maxWidth: 480,
	      title: 'Join over 2 million people collaborating with Marvel. Get started for free.'
	    })
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"background":"src-pages-features-collaboration-style----general-module---background---3U8fb"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-collaboration-index-js-8490de74287aca903ffe.js